import React from 'react';
import { getEnv } from 'config/enviroment';
import * as S from './styles';

export default function VersaoData() {
  const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  const diaPorExtenso = new Date().toLocaleString('pt-br', options);

  const ENV = getEnv();

  return (
    <S.FooterWhite>
      <S.Versao>
        <p>Versão {ENV?.VERSAO}</p>
        &nbsp;Em {ENV?.DATA_VERSAO}
        <S.LocalData>Salvador, {diaPorExtenso}</S.LocalData>
      </S.Versao>
    </S.FooterWhite>
  );
}
